import NotificationBell from './notification-bell.connect'
export default NotificationBell
